var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.69913 20.2692L13.9486 5.97995C14.5701 4.90406 14.2012 3.52762 13.1253 2.90678C12.0494 2.28523 10.6729 2.65421 10.0521 3.7301L1.80192 18.0194C1.18037 19.0953 1.54935 20.4717 2.62525 21.0932C3.70114 21.7148 5.07828 21.3451 5.69913 20.2692Z",
    fill: "url(#paint0_linear_290_10547)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0515 5.97995L18.3016 20.2692C18.9232 21.3451 20.2989 21.7141 21.3748 21.0925C22.4507 20.471 22.8197 19.0953 22.1981 18.0194L13.9487 3.7301C13.3271 2.65421 11.9514 2.28523 10.8755 2.90678C9.7996 3.52833 9.43062 4.90406 10.0522 5.98066L10.0515 5.97995Z",
    fill: "url(#paint1_linear_290_10547)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75058 21.3945C4.99314 21.3945 6.00044 20.3872 6.00044 19.1446C6.00044 17.9021 4.99314 16.8948 3.75058 16.8948C2.50803 16.8948 1.50073 17.9021 1.50073 19.1446C1.50073 20.3872 2.50803 21.3945 3.75058 21.3945Z",
    fill: "#7D0DC5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 7.10456C13.2424 7.10456 14.2497 6.09726 14.2497 4.85471C14.2497 3.61215 13.2424 2.60486 11.9999 2.60486C10.7573 2.60486 9.75 3.61215 9.75 4.85471C9.75 6.09726 10.7573 7.10456 11.9999 7.10456Z",
    fill: "#00FFAA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2501 21.3945C21.4927 21.3945 22.4999 20.3872 22.4999 19.1446C22.4999 17.9021 21.4927 16.8948 20.2501 16.8948C19.0075 16.8948 18.0002 17.9021 18.0002 19.1446C18.0002 20.3872 19.0075 21.3945 20.2501 21.3945Z",
    fill: "#FFDA00"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_290_10547",
    x1: 13.1253,
    y1: 2.90708,
    x2: 2.62566,
    y2: 21.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0080FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_290_10547",
    x1: 16.1258,
    y1: 21.3945,
    x2: 16.1258,
    y2: 2.60482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D0DC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1B92"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a6d203a929017973166d841140a4b585.svg";
export { ForwardRef as ReactComponent };